import { gsap, Sine, Power0, Power1, Power2, Power3, Power4,back } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import Swiper from 'swiper/bundle';

import TomSelect from 'tom-select/dist/js/tom-select.complete.js';

gsap.registerPlugin(ScrollToPlugin)
gsap.registerPlugin(ScrollTrigger);

import { Fancybox } from "@fancyapps/ui";

import Odometer from 'odometer/odometer.js';


// FUNCTION
// =======================================================
function isInPage(node) {
  return (node === document.body) ? false : document.body.contains(node);
}

// DOM 
// =======================================================

const frame = document.querySelector('.l-frame');
const gsearch = document.querySelector('.u-gsearch');


// window.onload = handle_md(mediaQuery_md);

// mediaQuery_md.addEventListener("change", handle_md);

// function handle_md(md) {
//   if (md.matches) {
//     const gsearchParentNode = document.querySelector('.l-drawer-column__right');
//     const pickupParentNode = document.querySelector('.l-drawer-footer .l-drawer-container');
//     const gsearchPos = document.querySelector('.l-drawer-column__right .l-drawer-flex');

//     gsearchParentNode.insertBefore(gsearch, gsearchPos);
//     pickupParentNode.insertBefore(pickup, null);
//   } else {
//     const gsearchParentNode = document.querySelector('.l-drawer-column__right');
//     const pickupParentNode = document.querySelector('.l-drawer-column__right .l-drawer-flex');
//     const gsearchPos = document.querySelector('.u-listsns');
//     const picPos =  document.querySelector('.u-listlinks--cols2');
    
//     gsearchParentNode.insertBefore(gsearch, gsearchPos);
//     pickupParentNode.insertBefore(pickup, picPos.nextSibling);
//   }
// }


// DRAWER
// =======================================================

const drawer = document.querySelector('.l-drawer');
if( isInPage(drawer) ) {
  const drawerBtn = document.querySelector('.l-drawer-btn');
  const navList = drawer.querySelectorAll('.l-drawer--nav li');
  const tagList = drawer.querySelector('.l-drawer .c-tags');
  
  gsap.set(drawer, {"display": "none", autoAlpha: 1});
  
  var tlDrawer = gsap.timeline({
    paused: true,
    onReverseComplete: function () {
      gsap.to( ".l-drawer .l-drawer--bg", 0.3, {
        opacity: 0,
        ease: Sine.easeInOut,
      }, "-=0.1");
      gsap.to( navList, 0.3, {
        opacity: 0,
        ease: Sine.easeInOut,
      }, "-=0.1");
      gsap.to( tagList, 0.3, {
        opacity: 0,
        ease: Sine.easeInOut,
        onComplete: function(){
          gsap.set(drawer, {"display": "none"});    
        }
      }, "-=0.1");
    },
    onComplete: function() {
      gsap.set(drawer, {"display": "block"});
      gsap.to( ".l-drawer .l-drawer--bg", 0.3, {
        opacity: 1,
        ease: Sine.easeInOut,
      });
      gsap.to( navList, 0.3, {
        opacity: 1,
        stagger: 0.05,
        ease: Sine.easeInOut,
      }, "-=0.1");
      gsap.to( tagList, 0.3, {
        delay: 0.3,
        opacity: 1,
        ease: Sine.easeInOut,
      });
    }
  });
  
  tlDrawer.to(".drawer", 0.3, {
    opacity: 1,
    visibility: "visible",
    pointerEvents: "auto",
    ease: Sine.easeInOut,
  });
  
  tlDrawer.reverse();
  
  drawerBtn.addEventListener('click', function (e) {
    e.preventDefault();
    drawerBtn.classList.toggle("is-open");
    drawer.classList.toggle("is-open");
    tlDrawer.reversed(!tlDrawer.reversed());
  });
  
}


// DRAWER - 1cols
// =======================================================

const drawer_1cols = document.querySelector('.l-drawer-1cols');

if(isInPage(drawer_1cols)) {
  const drawerBtn02 = document.querySelector('.l-drawer-btn02');
  const navList02 = drawer_1cols.querySelectorAll('.l-drawer--nav .c-btn');
  
  gsap.set(drawer_1cols, {"display": "none", autoAlpha: 1});

  var tlDrawer02 = gsap.timeline({
    paused: true,
    onReverseComplete: function () {
      gsap.to( ".l-drawer-1cols .l-drawer--bg", 0.3, {
        opacity: 0,
        ease: Sine.easeInOut,
      }, "-=0.1");
      gsap.to( navList02, 0.3, {
        opacity: 0,
        ease: Sine.easeInOut,
        onComplete: function(){
          gsap.set(drawer_1cols, {"display": "none"});    
        }
      }, "-=0.1");
    },
    onComplete: function() {
      gsap.set(drawer_1cols, {"display": "block"});
      gsap.to( ".l-drawer-1cols .l-drawer--bg", 0.3, {
        opacity: 1,
        ease: Sine.easeInOut,
      });
      gsap.to( navList02, 0.3, {
        opacity: 1,
        stagger: 0.05,
        ease: Sine.easeInOut,
      }, "-=0.1");
    }
  });

  tlDrawer02.reverse();

  tlDrawer02.to(drawer_1cols, 0.3, {
    opacity: 1,
    visibility: "visible",
    pointerEvents: "auto",
    ease: Sine.easeInOut,
  });

  drawerBtn02.addEventListener('click', function (e) {
    e.preventDefault();
    drawerBtn02.classList.toggle("is-open");
    drawer_1cols.classList.toggle("is-open");
    tlDrawer02.reversed(!tlDrawer02.reversed());
  });
  
}


// SWIPER
// =======================================================

// show carousel
let carousel = null;
const mediaQuery = window.matchMedia('(max-width: 767px)');


const bgSlider = new Swiper('.swiper-bg', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },  
  loop: true,
  speed: 2000,
  allowTouchMove: false,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});

const newsCarousel = new Swiper('.recent-carousel', {
  slidesPerView: "auto",
  centeredSlides: true,
  centerMode: true,
  spaceBetween: 0,
  initialSlide: 0,
  speed: 1000,
  loop: false,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  grabCursor: true,
  pagination: {
    el: '.recent-carousel-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.recent-button-next', // 「次へ」ボタン要素のクラス
    prevEl: '.recent-button-prev', // 「前へ」ボタン要素のクラス
  },
  breakpoints: {
    1280: {
      slidesPerView: 1,
      // centerMode: true,
      // centeredSlides: true,
      // centerMode: true,
    },
  },
});


// Fancybox
// =======================================================

Fancybox.bind('a:not([target="_blank"])[href$=".jpg"], a:not([target="_blank"])[href$=".png"], a:not([target="_blank"])[href$=".gif"]', {
  hideScrollbar: true,
  Thumbs: {
    type: "classic",
  },  
  Toolbar: {
    display: {
      left: [],
      middle: [],
      right: ["slideshow","fullscreen", "thumbs", "close"],
    }
  }  
});


// GO TO TOP
// =======================================================

const btnReturnBtn = document.querySelector('.btn-top button');

if(isInPage(btnReturnBtn)) {
  btnReturnBtn.addEventListener("click", function(e) {
    gsap.to(window, {
      duration: 1,
      scrollTo: {
        y: 0,
        autoKill: false
      },
      ease: 'power2'
    });
  });
}


// FORM
// =======================================================

var form = document.querySelector('.contact-form');
// form.classList.add('h-adr');
// var radiobtn = document.querySelectorAll('[name="applicant"]');
// radiobtn.forEach( btn => {
//   if(btn.checked) {
//     checkValue(btn.value);
//   }
//   btn.addEventListener("change", function(e){
//     checkValue(e.currentTarget.value);
//   });
// });
if( isInPage(form) ) {
  var pp = document.querySelector('.c-field-check input[type="checkbox"]');
  var confirmBtn = document.querySelector('.c-btn-confirm');
  if(pp.checked) {
    confirmBtn.disabled = false;
  }
  else {
    confirmBtn.disabled = true;
  }
  pp.addEventListener("change", function(e){
    if(this.checked) {
      confirmBtn.disabled = false;
    }
    else {
      confirmBtn.disabled = true;
    }
  });
  
  const select = document.querySelector(".custom-select");
  
  // new TomSelect(select,{
  // 	create: true,
  // 	sortField: {
  // 		field: "text",
  // 		direction: "asc"
  // 	}
  // });
  
  const control = new TomSelect(select,{
    hidePlaceholder: true,
    onInitialize: function(){
      if (window.matchMedia('(max-width: 768px)').matches) {
        var parentElm = closest(select, ".c-grid-cell");
        var input = parentElm.querySelector("input");
        input.disabled = true;
        input.style.pointerEvents = "none";
      }
    }
  });
}

// Odometer
// =======================================================

var countbox = document.querySelector('.papers-result .count');
if(isInPage(countbox)) {
  const count = countbox.dataset.count;
  const duration = 500;
  
  var startValue = "";
  for (let i = 0; i < count.toString().length; i++) {
    startValue = startValue + "0";
  }
  
  var od = new Odometer({
    el: countbox,
    auto: false,
    value: startValue,
    format: '(,ddd).dd',
    duration: duration,
    theme: 'default',
  });
  
  countbox.innerHTML = count;
  
  setTimeout(function(){
    countbox.classList.add("is-finish");
  }, duration);
}


// GSAP
// =======================================================

const floatNav = document.querySelector(".c-float-btns");

console.log(floatNav);

if(floatNav != null) {
  const fadeInFloatNav = gsap.timeline({
    scrollTrigger: {
      trigger: 'body',
      start: innerHeight/2 + ' top',
      onEnter: () => {
        gsap.to(floatNav, { y: "0%", duration: 0.3, ease: Sine.easeOut });
      },
      onLeaveBack: () => {
        gsap.to(floatNav, { y: "100%", duration: 0.3, ease: Sine.easeOut });
      },
    }
  });
}
